import React,{ useState, useEffect, useRef } from 'react';
import * as marked from "marked";
import {Image as AntdImage, Popconfirm, Typography, Space, message, Spin, Tooltip, Pagination, Checkbox, Button, Popover, Empty} from 'antd';
import { HistoryOutlined, CloudDownloadOutlined, CheckCircleOutlined, ArrowUpOutlined, CloseCircleOutlined, ClearOutlined, ExclamationCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { useSelector, useDispatch } from "react-redux";
import $ from 'jquery'

import HistoryTopic from './components/HistoryTopic/index'
import Iconfont from '../Iconfont/Iconfont';
import storage from "../../utils/storage";
import Api from "../../api/index";
import {responseDataFilter, downloadFileBlob, copyToClip} from '../../utils/tool';
import { processingDataFormat } from '../../utils/aiTool';
import { setAIModalState } from "../../features/AIIntelligent/AIReducer";
import newTopic from "../../assets/img/V7/newTopic.svg";
import aiIcons from "../../assets/img/V7/aiIcon.svg";
import aiText from "../../assets/img/V7/aiText.svg";
import './index.scss';

const {Title, Text, Link} = Typography;
let eventSource = null;
const AIModalV7 = ({searchValue, historyTopicId, aiType, callbackPositioning, status, pageType}) => {
    const contentRef = useRef(null);
    const userInfo = storage.getItem("userInfo") || {};
    const dispatch = useDispatch();

    const [chatIsCreating, setChatIsCreating] = useState(false) // 聊天室是否处于创建中
    const [isAnswering, setIsAnswering] = useState(false) // 是否正在回答问题
    const [inputMessageLength, setInputMessageLength] = useState(0) // 聊天框字数
    const [sendQuestionText, setSendQuestionText] = useState("");// 需要发送的问题
    const [inputText, setInputText] = useState("");// 输入框的文字
    
    const questionLocation = useSelector(state => state.AIModal.questionLocation);
    // 0 带文档的问答， 1 知识中心 ， 2 ES搜索界面， 3查讯全部

    const questionModule = useSelector(state => state.AIModal.questionModule);// 问题类型 “检索ragRetrieve，问答ragChat 文档总结summary”
    const knowledgeIds = useSelector(state => state.AIModal.knowledgeIds); //需要提问的知识id
    const knowledgeEsParam = useSelector(state => state.AIModal.knowledgeEsParam); //需要提问知识范围
    const selectKnowledgeParam = useSelector(state => state.AIModal.selectKnowledgeParam); //需要提问知识范围
    const knowledgePublishedParam = useSelector(state => state.AIModal.knowledgePublishedParam); //个人中心分享成功的参数
    // const historyTopicId = useSelector(state => state.AIModal.historyTopicId); //历史记录ID
    // const QAtype = useSelector(state => state.AIModal.QAtype); // rec推荐知识， sum文档总结
    const refLoc = useSelector(state => state.AIModal.refLoc); // 是否开启来源定位，默认为False
    const sendAPI = useSelector(state => state.AIModal.sendAPI); // 是否开启来源定位，默认为False
    const queryText = useSelector(state => state.AIModal.queryText); // 提问的内容
    const relQuestions = useSelector(state => state.AIModal.relQuestions); // 推荐问题的数量

    const multiChatId = useSelector(state => state.AIModal.multiChatId);
    
    const [answerDataList, setAnswerDataList] = useState([]) // 会话信息列表
    const [expandKeyObject, setExpandKeyObject] = useState([]) // 回复消息下展开来源key
    const [isFocus, setIsFocus] = useState(false)
    const [chatId, setChatId] = useState(null) //问答记录id
    const [clientId, setClientId] = useState(null);
    const [lmQaLogId, setLmQaLogId] = useState(null);

    // 最新一条AI回复的内容的ID
    const [largeModelQaLogDeatilId, setLargeModelQaLogDeatilId] = useState(null)
    const [isStop, setIsStop] = useState(false) // 是否中断
    
    // 历史对话
    const [historyTopicOpen, setHistoryTopicOpen] = useState(false);
    const [historyPageParam, setHistoryPageParam] = useState({
        pageIndex: 1,
        total:0
    });
    const [searchParam, setSearchParam] = useState({
        lmQaLogId:null,
        pageIndex: 1,
        pageSize:10
    });
    const [moreLoading, setMoreLoading] = useState(false);

    // 导出makdown
    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [exporting, setExporting] = useState(0); //是否正在导出中
    const [exportIds, setExportIds] = useState([]); // 需要导出的数据ID

    // 优化提问
    const [optimizing, setOptimizing] = useState(false);

    // 提问参数
    const [sendParam, setSendParam] = useState({})

    // 提示框
    const [aIModalTips,setAIModalTips] = useState(false)

    // 记录历史记录滚动的位置
    const [historyScrollTop,setHistoryScrollTop] = useState(0);
    const [historyPage, setHistoryPage] = useState({
        pageSize: 10,
        pageIndex: 1,
    });

    const [isAnswer, setIsAnswer] = useState(false);
    const [historyTotal, setHistoryTotal] = useState(0);
    const [noMore, setNoMore] = useState(true);

    useEffect(()=>{
        console.log("isAnswer",isAnswer)

    },[isAnswer])

    useEffect(()=>{
        // 单文档
        // 判断  (String(status) === '0'

        // 多文档问答 pageType === "multiAi" 
        // 全部可以问
        if(pageType === "multiAi"){
            setIsAnswer(true);
        }else{
            setIsAnswer(String(status) === '0' ? true : false);
        }

    },[status]);

    useEffect(()=>{
        if(sendAPI){
            sendConnection('', questionModule);
        }
    },[sendAPI])


    // 点击历史记录
    useEffect(()=>{
        if(searchParam.lmQaLogId){
            getQAHistory(searchParam.pageIndex > 1 ? '' : 'history');
        }
    },[searchParam])


    // 结束当前话题的提示框
    useEffect(()=>{
        if(aIModalTips && aIModalTips.timeOut != 'maintain'){
            setTimeout(()=>{
                setAIModalTips(false);
            },2000)
        }
    },[aIModalTips])


    // 查询历史记录
    useEffect(() => {
        if(historyTopicId){
            onClickHistoryDetails(historyTopicId);
            setChatId(historyTopicId);
        }
    }, [historyTopicId])
    
    
    //AI小赛助手-多文档查讯历史记录 
    useEffect(() => {
        if(multiChatId){
            setAnswerDataList([]);
            onClickHistoryDetails(multiChatId);
            setChatId(multiChatId);
        }
    }, [multiChatId])


    useEffect(() => {
        const handleClick = (event, dataList) => {
          // 确保点击事件来自于设置的HTML内容
          if (contentRef.current && event.target.closest('.onClickKnowledgeDetails') && questionLocation != 1 && questionLocation != 2) {
            let num = event.target.textContent;
            console.log(event.target,"target")
            console.log(event.target.dataset,event.target.dataset.myData,"myData");


            if(num === "Excel"){
                return false;
            }
            
            num = num.replace('P', '')
            // num = num.replace('[', '').replace(']', '')
            if(callbackPositioning){
                console.log(num, "num")
                callbackPositioning(num)

                // 单文档 - 知识详情中问答 -- 点击直接当前页s定位
                // dataList.map(item=>{ 
                //     if(item.id === id){ 
                //         let sourceItem = item.sources[num]
                //         callbackPositioning(sourceItem.pages)
                //     }
                // })

            }
          }
        };
     
        if(!isAnswering){
            // 添加点击事件监听器到document
            document.addEventListener('click', (event)=>{
                handleClick(event, answerDataList)
            });
        }else{
            document.removeEventListener('click', (event)=>{
                handleClick(event, answerDataList)
            });
        }
        
     
        // 清理函数，组件卸载时移除事件监听
        return () => {
          document.removeEventListener('click', (event)=>{
                handleClick(event, answerDataList)
            });
        };
      }, [isAnswering, answerDataList]);
    

    // 内容滚动到底部
    useEffect(()=>{
        if (historyPage.pageIndex === 1 && searchParam.pageIndex === 1) {
            // 查询历史的时候，大于1页后不滚动
            chatAreaScrollBottom();
        }
    },[answerDataList])

    // useEffect(()=>{
    //     if(historyScrollTop){
    //         const dom = document.getElementById("chatScrollBox"); 
    //         if (dom) {
    //             dom.scrollTop = dom.scrollHeight - historyScrollTop;
    //         }
    //         setHistoryScrollTop(0)
    //     }else{
    //         chatAreaScrollBottom();
    //     }
    // },[answerDataList])


    useEffect(()=>{
        console.log("useEffect",noMore)
        if(!noMore){
            const dom = document.getElementById("chatScrollBox"); 
            if (dom) {
                addEventListenerF();
            }
        }else{
            removeEventListenerF();
        }
    },[noMore])
    
    
    const addEventListenerF = () => {
        if(document.getElementById('chatScrollBox')){
            document.getElementById('chatScrollBox').addEventListener("scroll",useFn);
        }
    }

    const removeEventListenerF = () => {
        if(document.getElementById('chatScrollBox')){
            document.getElementById('chatScrollBox').removeEventListener("scroll", useFn);
        }
    }


    /**
     * 判断是否触底
     * 此函数进行判断是否触底
     * @param    handler  必填  判断后执行的回调函数
     * @returns  null
     */
    const isTouchBottom = (handler, noMore) => {

        let scrollTop = Math.ceil(document.querySelector('#chatScrollBox').scrollTop);
        
        if(scrollTop === 0){
            handler();
        }
    };
    const handleLoadMore = () => {

        removeEventListenerF();

        setMoreLoading(true);
        
        setSearchParam({
            ...searchParam,
            "pageIndex":searchParam.pageIndex+1,
        });
    };
    const useFn = () => {
        // 此处调用 加载更多函数
        isTouchBottom(handleLoadMore, noMore);
    };

    // 发送问题
    const sendText = (value) => {
        let text = value ? value : sendQuestionText;
        if (text.replace(/\s/g, "").length > 0) {
            let newDataList = [...answerDataList];
            let id = Date.now().toString()
            newDataList.push({
                id,
                userId: userInfo.userId,
                messageContent: text,
                messageData:{
                    query: text,
                },
                logType:0
            });

            newDataList.push({
                logType: "ansewrLoading",
                id: Date.now().toString() + "1",
            });
            
            setAnswerDataList(newDataList);
            chatAreaScrollBottom();
            setInputText("");
            setSendQuestionText("");
            setInputMessageLength(0);
            setInputTextF();
            sendConnection('','',newDataList);
        } else {
            message.warning("输入的问题不能为空！");
        }
    }


    // 创建会话
    const sendConnection = (id, msgType, newDataList) => {
        setIsAnswering(true);
        let data = {
            param: {
                chatType: "rag",
                messageData: {
                    query: sendQuestionText || queryText,
                    msgType: msgType ? msgType : 'ragChat', //消息子类型 sys/ragChat/summary/ragRetrieve
                    relQuestions: 3, //问题推荐数量
                    useKb: true,
                    modelKey:'Qwen3-32B-v0.9.2',
                },
            },
            ext: {
                knowledgeIds: knowledgeIds,
                lmQaLogId: lmQaLogId,
                questionLocation:0
            },
        }

        
        setSendParam(data);

        // 第一次问答的时候
        setAIModalTips({
            status:'loading',
            msg: '正在分析，请耐心等待...',
            position: 'top',
            timeOut: 'maintain'
        })

        eventSource = fetchEventSource("/api/lm/chat/createConnect", {
            openWhenHidden: true,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "text/event-stream",
                satoken: storage.getItem("token"),
            },
            onmessage(event) {
                // 在这里操作流式数据
                console.info("接受到回复：",event.data);
                if(event.data){
                    receiveMessage(event, id, data, newDataList)
                }
            },
            onclose(ee) {
                // 关闭流
                console.log("关闭")
            },
            onerror(error) {
                console.info(error);
                stopInputAnswerFunc();
                throw error;
                // return 5000;
                // 如果抛出时间，则间隔多少时间重连
                //返回流报错
            }
        })
    }

    const stopInputAnswerFunc = () => {
        setIsAnswering(false);
        closeConnection();
        setAIModalTips(false)
    }


    // 接收消息
    const receiveMessage =(evt, reAnswerId, postData, newDataList) => {
        try {
            const data = evt.data;
            let decodeData = null, messageInfo = null;
            if (data) {
                decodeData = JSON.parse(data);
            } else {
                setIsAnswering(false);
                console.error("数据格式错误1:", data);
                return false;
            }
            
            if (decodeData.clientId) {
                setClientId(decodeData.clientId);
                if (reAnswerId) {
                    // 重新问答
                    historyPage.pageIndex = 1;
                    getQAHistory("reAnswers");

                    sendReAnswers({
                        clientId: decodeData.clientId,
                        id: reAnswerId,
                    })
                } else {
                    postData.ext.clientId = decodeData.clientId;
                    sendQuestionParam(postData)
                }
            } else if (decodeData.data) {
                messageInfo = decodeData.data;
            } else {
                setIsAnswering(false);
                console.error("数据格式错误2:", decodeData.data);
                return false;
            }

            
            if (messageInfo && messageInfo.data) {
                let _data = messageInfo.data;
                setLmQaLogId(_data.lmQaLogId);
                _data.logType =  "ansewrLoading"
                if (_data.isEnd) {
                    _data.logType =  ""
                    console.log(messageInfo.data, "messageInfo");
                    console.log(answerDataList, "结束");
                    setIsAnswering(false);
                    // 关闭连接
                    closeConnection();
                }

                let formatContent = marked.parse(_data.answer || "");
                _data.answer = formatContent;
                _data.answerText = formatContent.replace(/<[^>]*>/g, "");
                _data.code = _data.code;
                _data.think = _data.think;
                _data.sourcesTotal = 
                (_data.sources ? _data.sources.length : 0) +
                (_data.publicSources ? _data.publicSources.length : 0)+
                (_data.exSources ? _data.exSources.length : 0)+
                (_data.webSources ? _data.webSources.length : 0)
                if (_data.think) {
                    if (_data.answer) {
                        _data.thinkOpen = false;
                    } else {
                        _data.thinkOpen = true;
                    }
                } else {
                    _data.thinkOpen = false;
                }

                let _newDataList =  newDataList ? [...newDataList ] : [...answerDataList];
                if (_data.isEnd) {
                    setAIModalTips(false);
                    console.log("newDataList123", _newDataList);
                }

                if(_newDataList.length === 0){
                    _data.msgType = "summary"
                }

                _newDataList[_newDataList.length > 1 ? (_newDataList.length - 1) : 0] = _data;
                setAnswerDataList(_newDataList);

            } else {
            }

            chatAreaScrollBottom();
        } catch (e) {
            // setIsAnswering(false);
            console.log(e);
        }
    }

    const sendQuestionParam = async(postData) => {
        try{
            let res = await Api.ChatV7.sendQAParam({data: postData})
            if(res&&res.code === 0){

            }
        }catch(e){ 
        }
    }   

    // 重新回答
    const reAnswers = (item) => {
        sendConnection(item.parentId);
    }

    // 获取历史会话
    const getQAHistory = async(type) => {
        
        let response = await Api.ChatV7.pageQa({data: 
                type === "reAnswers" ? {
                lmQaLogId: lmQaLogId,
                pageSize: historyPage.pageSize,
                pageIndex: historyPage.pageIndex,
            } : searchParam
        })
        
        if (response.code === 200 && response.rows.length > 0) {
            let historyData = [];
            
            if (type === "reAnswers") {
                historyData = [...response.rows.reverse()];
                historyData[historyData.length - 1].logType = "ansewrLoading";
                historyData[historyData.length - 1].answer = "";
            } else if (type === "history") {
                historyData = [...response.rows.reverse()];
            } else {
                historyData = [...response.rows.reverse(), ...answerDataList];
            }
            
            historyData.map((item) => {
                let formatContent = marked.parse(item.answer || "");
                item.answer = formatContent;
                item.answerText = formatContent.replace(/<[^>]*>/g, "");
            });
            setAnswerDataList(historyData);
            setLmQaLogId(response.rows[0].lmQaLogId);
            setHistoryTotal(response.total);
            setMoreLoading(false);

            if (historyPage.pageIndex === 1 && searchParam.pageIndex === 1) {
                setTimeout(() => {
                    chatAreaScrollBottom();
                }, 600);
            }
            
            if (
                searchParam.pageIndex >= (response.total / searchParam.pageSize)
            ) {
                setNoMore(true);
                removeEventListenerF();
            } else {
                setNoMore(false);
            }
        } else {
            setAnswerDataList([])
        }
    }

    // 发送重新问答的参数
    const sendReAnswers = async(param) => { 
        try{
            const response = await Api.ChatV7.reAnswer({data:param})
            if (response.code === 0) {}
        }catch(e){}
    }

    const renderChatList = () => {
        return (
            <div id="chatScrollBox" className={`chatScrollBox`}>
                {moreLoading&&<Spin tip={"加载中..."} size={"small"} style={{width: "100%"}}></Spin>}
                {
                    answerDataList?.map((item, idx) => {
                        // aiType = detailsSum 知识详情页面
                        // 知识中心 ES 等Ai帮我找的时候，只需要显示推荐问题
                        // 知识详情 - 多文档问答的时候，查讯历史记录只需要显示推荐问题
                        if(!item){return false;}

                        const {id, think, messageData, logType, answer, parentId, isEnd, relQuestions, questionType, status: supportStatus, sources, msgType, largeModelQaLogId} = item;
                        
                        // logType: 0, //0发送消息 1接收消息
                        const isSelf = logType === 0;
                        
                        // 是否是总价
                        const isSummary = msgType === 'summary';

                        const messageContentId = `messageContent-${id}`;
                        
                        let formatContent = "";
                        if(isSelf && messageData && messageData.query){
                            formatContent = messageData.query;
                        }else if(answer){
                            formatContent = marked.parse(answer || "");
                        }
                        // 去掉最后一个换行
                        formatContent = formatContent.replace(/[\n|\r]$/, "");
                        
                        // 处理数据格式
                        let detailsID = parentId ? parentId : id;
                        
                        formatContent = processingDataFormat(formatContent, id, "onClickKnowledgeDetails", sources)
                        
                        return (
                            <div className={`${exporting != 0 ? "selectingStatus" : ""}`} key={id}>
                                <div className={`chatMessageItem ${exportIds.includes(id)?'selectedStatus':''}`}>
                                    <div>
                                        {logType === "ansewrLoading" && <Spin size={"small"} style={{marginLeft: 10}}></Spin>}
                                    </div>

                                    {/* 多选框 */}
                                    {!isSelf&&<i className={`checkBox checkBoxLeft`} onClick={()=>handleSelect(id)}/>}

                                    {/* 消息行 */}
                                    <div className={`chatMessage ${isSelf ? "selfChatMessage" : ""}`}>
                                        
                                        {/* 消息 */}
                                        <div
                                            className="messageContentBox"
                                            style={{maxWidth: "40rem",}}
                                        >
                                            {
                                            // {/* AI帮我读 - 知识详情页面 - 默认需要显示核心观点+推荐问题 */}
                                            // {/* Core viewpoint + recommended questions */}
                                            isSummary ? getCoreAndRec(item, formatContent) : 
                                            

                                            // 自己的提问内容
                                            isSelf ? qQuestionContent(item, formatContent) : 

                                            // AI回答的内容
                                            <>
                                                {think&&<>
                                                    <span className="deepThinkingBtn" onClick={()=>handleChangeThink(item)}>
                                                        已深度思考
                                                        <Iconfont type={item.thinkOpen ? "icon-xiala" : "icon-shangjiantou4"} />
                                                    </span>
                                                </>}
                                                {think&&item.thinkOpen&&<div className="deepThinkingContent">{item.think}</div>}
                                                
                                                <div
                                                    ref={contentRef}
                                                    className={`messageContent answerMessageContent`}
                                                    id={messageContentId}
                                                    dangerouslySetInnerHTML={{__html: formatContent}}
                                                ></div>

                                                {
                                                    (!isSelf && !isSummary) ? (
                                                        <React.Fragment>

                                                            {/* 底部操作 */}
                                                            {isEnd && <div className="operateBtnBox"> 
                                                                <div>
                                                                    {/* 复制 */}
                                                                    {answer&&<span
                                                                        className={`operateBtn`}
                                                                        onClick={() => copyAnswers(item)}
                                                                    ><Iconfont type="icon-fuzhi1"/></span>}
                                                                    {/* 删除 */}
                                                                    {(id && (think || answer)) && <Popconfirm
                                                                        title="确定删除这条回答信息吗?"
                                                                        onConfirm={()=>deleteAnswers(item)}
                                                                        okText="确定"
                                                                        cancelText="取消"
                                                                    >
                                                                        <span
                                                                            className={`operateBtn`}
                                                                        ><Iconfont type="icon-delete"/></span>
                                                                    </Popconfirm>}
                                                                    
                                                                    {parentId && <span
                                                                        className={`operateBtn`}
                                                                        onClick={()=>reAnswers(item)}
                                                                    >
                                                                        <Iconfont type="icon-tongbu"/>
                                                                        <span className="operateBtnText">重新回答</span>
                                                                    </span>}
                                                                    {(id && (think || answer)) && <Tooltip 
                                                                        placement={"top"} 
                                                                        title={"答得不错"}
                                                                    >
                                                                        <span
                                                                            className={`operateBtn ${item.msgView === 0 ? "lightStatus" : ""}`}
                                                                            onClick={() => {
                                                                                likeOrDisLike(item,'like');
                                                                            }}
                                                                        ><Iconfont type="icon-dianzan"/></span>
                                                                    </Tooltip>}
                                                                    {(id && (think || answer)) && <Tooltip placement={"top"} title={"还不够好"}
                                                                    >
                                                                        <span
                                                                            className={`operateBtn ${item.msgView === 1 ? "lightStatus" : ""}`}
                                                                            onClick={() => {
                                                                                likeOrDisLike(item,'dislike');
                                                                            }}
                                                                        ><Iconfont type="icon-diancai"/></span>
                                                                    </Tooltip>}
                                                                </div>

                                                                

                                                                {item.totalPage && item.totalPage > 1 && <Pagination 
                                                                    simple 
                                                                    current={item.pageIndex ? item.pageIndex: item.totalPage} 
                                                                    total={Number(item.totalPage)}  
                                                                    pageSize={1}
                                                                    onChange={(page, pageSize)=>paginationChange({
                                                                        currentPage: page,
                                                                        pageSize: pageSize,
                                                                        param: item,
                                                                    })}
                                                                />}
                                                            </div>}
                                                        </React.Fragment>
                                                    ) : undefined
                                                }

                                                {/* AI推荐的问题 */}
                                                {relQuestions?.length > 0 && <div className='RecommendQ'>
                                                    {relQuestions.map(items=>{
                                                        return <div key={items} className='relQuestionItem' onClick={()=>{handleRelQuestion(items)}}>{items}</div>
                                                    })}
                                                </div>}

                                            </>}

                                            
                                        </div>
                                    </div>
                                    
                                    {/* 多选框 */}
                                    {isSelf&&<i className={`checkBox checkBoxRight`} onClick={()=>handleSelect(id)}/>}
                                </div>
                            </div>
                        )
                    })
                }

                {/* 导出确认弹窗 */}
                {exportModalOpen&&<div className="exportConversationTips">
                    <div className='mask'></div>
                    <div className='content'>
                        <div><ExclamationCircleOutlined /> 自动剔除“还不够好”的回答？</div>
                        <div className='footer'>
                            <Button shape="round" size="small" onClick={()=>nextStep(true)}>否，为我保留</Button>
                            <Button type="primary" shape="round" size="small" onClick={()=>nextStep()}>是，继续下一步</Button>
                        </div>
                    </div>
                </div>}
            </div>
        )
    }


    // 深度思考
    const handleChangeThink = (param) => {
        let newDataList = [...answerDataList];
        newDataList.map((item) => {
            if (item.id === param.id) {
                item.thinkOpen = !item.thinkOpen;
            }
        });
        setAnswerDataList(newDataList)
    }

    // 修改点赞状态
    const likeOrDisLike = async(param,type) => {
        let msgView = "";
        if (type === "dislike") {
            msgView = param.msgView === 1 ? 2 : 1;
        } else if (type === "like") {
            msgView = param.msgView === 0 ? 2 : 0;
        }
        try{
            const res = await Api.ChatV7.evaluate({
                data:{
                    id: param.id,
                    msgView: msgView, //0 点赞，1 点踩  2 取消
                }
            })
            if (res.code === 0) {
                let newDataList = [...answerDataList];
                newDataList.map((item) => {
                    if (item.id === param.id) {
                        item.msgView = msgView;
                    }
                });
                setAnswerDataList(newDataList);
            }
        }catch(e){}
    }

    // 复制
    const copyAnswers = (item) => {
        var textarea = document.createElement("textarea");
        textarea.style.position = "fixed";
        textarea.style.opacity = 0;
        textarea.value = item.answerText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        message.success("复制成功");
    }

    // 删除
    const deleteAnswers = async(data) => {
        try{
            const response = await Api.ChatV7.deleteALog({data:{lmQaLogDetailId: data.id}})
            // 传参删除
            if (response.code === 0) {
                if (data.totalPage > 1) {
                    paginationChange({
                        currentPage: data.totalPage - 1,
                        pageSize: 1,
                        param: data,
                    });
                } else {
                    let newDataList = [...answerDataList];
                    newDataList.map((item, index) => {
                        if (item.id == data.id) {
                            // item = {
                            //     answerText:"暂无回答",
                            //     logType: "delete",
                            // }
                            newDataList.splice(index, 1);
                        }
                    });
                    
                    setAnswerDataList(newDataList);
                }
                message.success(`删除成功`);
            }

        }catch(e){}
    }

    // 翻页
    const paginationChange = async({ currentPage, pageSize, param }) => {
        console.log(currentPage, pageSize);
        try{
            const res = await Api.ChatV7.pageAByParentId({
                data:{
                    pageIndex: currentPage,
                    pageSize: pageSize,
                    parentId: param.parentId,
                }
            })
            if (res.code === 200) {
                
                let newDataList = [...answerDataList];
                newDataList.map((item) => {
                    if (item.id === param.id) {
                        let formatContent = marked.parse(res.rows[0].answer || "");
                        item.answerText = formatContent.replace(/<[^>]*>/g, "");
                        item.answer = formatContent;
                        item.id = res.rows[0].id;
                        item.relQuestions = res.rows[0].relQuestions;
                        item.msgView = res.rows[0].msgView;
                        item.totalPage = res.rows[0].totalPage;
                        item.pageIndex = currentPage;
                    }
                });
                setAnswerDataList(newDataList);
            }
        }catch(e){}
    }
    
    // 总结
    const getCoreAndRec = (item, formatContent) => {
        const {id, relQuestions} = item;
        const messageContentId = `messageContent-${id}`;
        return (
            <>
            <div className='sumTitle'>本文核心观点如下：</div>

            {/* AI回答的内容 */}
            <div
                ref={contentRef}
                className={`messageContent answerMessageContent`}
                id={messageContentId}
                dangerouslySetInnerHTML={{__html: formatContent}}
            ></div>

            <div className='sumTitle' style={{marginTop:'0.5rem'}}>你可能还想知道</div>

            {/* AI推荐的问题 */}
            {relQuestions?.length > 0 && <div className='RecommendQ'>
                {relQuestions.map(items=>{
                    return <div key={items} className='relQuestionItem' onClick={()=>{handleRelQuestion(items)}}>{items}</div>
                })}
            </div>}
        </>
        )
    }


    const qQuestionContent = (item, formatContent) => {
        const {id} = item;
        const messageContentId = `messageContent-${id}`;
        return (
            <div
                ref={contentRef}
                className={`messageContent messageContentQuery`}
                id={messageContentId}
                dangerouslySetInnerHTML={{__html: formatContent}}
            ></div>
        )
    }

    const nextStep = (selectAll = false) => {
        // 是否保留“还不够好”的回答。true 保留，false 不保留
        
        if(!selectAll){
            let newData = [];
            answerDataList.map(item=>{
                if(item.status != '1'){
                    newData.push(item.id)
                }
            })
            setExportIds(newData);
        }
        
        setExporting(2);
        setExportModalOpen(false);
    }

    // 改变导出对话的选择范围
    const handleSelect = (id) => {
        let newExportIds = [...exportIds]
        newExportIds.indexOf(id) === -1 ? newExportIds.push(id) : newExportIds.splice(newExportIds.indexOf(id), 1); 
        console.log(newExportIds,"newExportIds")
        setExportIds([...newExportIds])
    }
    
    
    

   

    // 聊天区域滚动到底部
    const chatAreaScrollBottom = () => {
        const dom = document.getElementById("chatScrollBox");
        if (dom) {
            dom.scrollTop = dom.scrollHeight;
        }
    }

    // 结束话题
    const endTopic = async() => {
        if(!lmQaLogId){
            message.info("当前没有有效对话");
            return false;
        }
        try {
            const res = await Api.ChatV7.endQA({
                data: {
                    lmQaLogId,
                },
            });
            if (res.code === 0) {
                setAIModalTips({
                    status:'success',
                    msg: "当前话题已结束！"
                })

                setLmQaLogId(null);
                setIsAnswering(false);
                setAIModalTips(false);

                let _newDataList = [...answerDataList];

                _newDataList.map((item) => {
                    if (item.logType === "ansewrLoading") {
                        item.logType = "ansewrStop";
                    }
                });

                setAnswerDataList(_newDataList);

                // message.success("结束话题成功！");
            }
        } catch (e) {
            console.log(e);
        }
    }

    
    // 关闭会话
    const closeConnection = async(type) => { 
        console.log(eventSource, "调用关闭");
        
        if (clientId) {
            let res = await Api.ChatV7.closeConnect({data: {
                clientId: clientId,
            }})
            if (res.code === 0) {
                console.log(res, "关闭成功");
                setClientId(null);
                setIsAnswering(false);
                setAIModalTips(false);
            } else {
                console.log(res, "关闭失败");
                message.error("停止对话失败");
            }
        }
        
        if (eventSource && eventSource.close) {
            eventSource.close(); // 关闭连接
            eventSource = null;
        }

        if(type === 'manualClick'){
            let _newDataList = [...answerDataList];
            _newDataList.map((item) => {
                if (item.logType === "ansewrLoading") {
                    item.logType = "ansewrStop";
                    item.isEnd = true;
                }
            });

            setAnswerDataList(_newDataList);
        }


        setIsAnswering(false)
    }


    const handleRelQuestion = (value) => {
        setSendQuestionText(value);
        setInputMessageLength(value.length)
        setInputTextF(value);
    }
    
    // 填写询问的问题
    const inputSendText = () => {
        const html = getInputText();
        setSendQuestionText(html);
        setInputMessageLength(html.length)
    }

    // 获取输入的问题
    const getInputText = () => {
        const dom = document.getElementById("inputContent");
        if (dom) {
            const result = dom.textContent;
            return result;
        }
    }
    const setInputTextF = (data) => {
        const dom = document.getElementById("inputContent");
        if (dom) {
            dom.innerHTML = data ? data : null;
        }
    }

    
    
    const onClickHistoryDetails = (id) => {
        setSearchParam({
            "lmQaLogId": id,
            "pageIndex": 1,
            "pageSize": 10,
        });
    }
    const getHistoryTopic = () =>{
        return (
            <div className="historyTopicBox">
                <HistoryTopic maxHeight={260} questionLocations={[questionLocation]} onClickHistoryDetails={onClickHistoryDetails}/>
            </div>
        )
    }

    // 查询历史对话明细
    const getHistoryTopicDetail = async(id) => {
        let dom = document.getElementById("chatScrollBox");
        setHistoryScrollTop(dom.scrollHeight);
        
        setHistoryTopicOpen(false);
        try{
            const res = await Api.Chat.getHistoryLogDetail({data:{
                largeModelQaLogId:id,
                ...searchParam
            }})

            const data = responseDataFilter(res);
            
            if(data.records && data.records.length > 0){
                let _data = [];
                data.records.map(item=>{ 
                    item.relQuestions = item.relQuestions ? JSON.parse(item.relQuestions) : [];
                    _data.unshift({
                        "id": item.id,
                        "userId": item.logType === 0 ? userInfo.userId : "robot", //0发送消息 1接收消息
                        "messageContent": item.message,
                        "parentId": item.parentId,
                        "relQuestions": item.relQuestions,
                        "questionType": item.questionType,
                        "sources":item.sources ? JSON.parse(item.sources) : [],
                        "query": item.query
                    })
                })
                setAnswerDataList([..._data,...answerDataList]);
                if(data.total > (data.current*data.size)){
                    addEventListenerF();
                }
                setHistoryPageParam({
                    pageIndex:data.current,
                    total:data.total,
                })
                setMoreLoading(false);
            }else{
                // 多文档的时候查讯历史记录，如果没有记录，就调用推荐问题
                console.log("没有历史记录")
                if(multiChatId){
                    dispatch(setAIModalState({
                        largeModelQaLogId:null,
                        queryText:"推荐问题",
                        questionModule:"summary",
                        relQuestions:2,
                        refLoc:false,
                        sendAPI: Date.now().toString()
                    }))
                }
            }
            setAIModalTips(false);
        }catch(e){
            console.log(e);
            setAIModalTips(false);
        }
    }

    // 导出对话记录
    const exportConversation = () => {
        setExportModalOpen(true);
        setExporting(1);
        // 默认先选中全部对话数据
        let ids = [];
        answerDataList.map(item=>{
            ids.push(item.id)
        })
        setExportIds(ids);
    }
    // 拼接对话
    const exportMakdown = () => {
        let text = '';
        answerDataList.map(item=>{
            if(exportIds.includes(item.id)){
                if(item.relQuestions?.length > 0){
                    text += `回答：${item.messageContent} /n`;
                    item.relQuestions.map(items=>{
                        text += `${items} /n`
                    })
                }else if(item.userId === 'robot'){
                    text += `回答：${item.messageContent} /n`
                }else{
                    text += `问：${item.messageContent} /n`
                }
            }
        })
        downloadMarkdown(text,"example.md")
    }
    // 导出
    const downloadMarkdown = (text, filename) => {
        // 创建Blob对象
        const blob = new Blob([text], { type: 'text/markdown' });
        
        // 创建临时的URL
        const url = URL.createObjectURL(blob);
        
        // 创建a标签并设置属性
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        
        // 模拟a标签点击来下载文件
        document.body.appendChild(a);
        a.click();
        
        // 清理临时DOM和URL
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        exportCancle();
    }
    // 关闭导出
    const exportCancle = () => {
        setExportModalOpen(false);
        setExporting(0);
        setExportIds([]);
    }

    // 光标移动到末尾
    const moveEnd = (dom) => {
        const selection = window.getSelection();
        const range = document.createRange();
        selection.removeAllRanges();
        range.selectNodeContents(dom);
        range.collapse(false);
        selection.addRange(range);
        dom.focus();
        setIsFocus(true)
    }

    const stopAnswer = () => {
        closeConnection('manualClick');
    }

    return (
        <div className="aiModalV7">
            <div>
                <Text className='aiTopLeftTitle' id='moveAIModal'>AI小赛助手</Text>
                <Space size={"large"} className='aiTopRight'>
                    <Popover
                        placement="bottomRight"
                        content={getHistoryTopic}
                        trigger="click"
                        getPopupContainer={()=>document.getElementById("historyTopic")}
                    >
                        <span id='historyTopic' className='historyTopicIcon'>
                            <HistoryOutlined /><Text type="secondary">历史对话</Text>
                        </span>
                    </Popover>

                    <Tooltip placement={"topRight"} title={"导出markdown"}
                        getPopupContainer={() => document.getElementById(`exportBotton`)}
                    >
                        <span
                            id={`exportBotton ${answerDataList.length < 1 ? " disabled" : ""}`}
                            onClick={()=>{
                                if(answerDataList.length > 0){
                                    exportConversation()
                                }
                            }}
                        >
                            <CloudDownloadOutlined />
                        </span>
                    </Tooltip>
                    
                </Space>
                
            </div>

            {/* 对话列表 */}
            <div className="chatListBox">
                {!isAnswer && <div className="knowledgeContentAITitle">
                    <div className="knowledgeContentAIImg">
                        <AntdImage
                            preview={false}
                            src={aiIcons}
                        />
                        <AntdImage
                            preview={false}
                            src={aiText}
                        />
                    </div>
                    <div className="knowledgeContentAIText">当前文档未解析完成，不可进行问答</div>
                </div>}

                {/* pageType !="multiAi" */}
                {answerDataList && answerDataList.length > 0 && renderChatList()}
                
            </div>

            {exporting === 2?(
                <div className='exportBtnBox'>
                    <Button type="primary" shape="round" size="small" onClick={()=>exportMakdown()}>导出makdown</Button>
                    <Button shape="round" size="small" onClick={()=>exportCancle()}>取消</Button>
                </div>
            ):(exporting === 0)  ? (<div>
                
                <div className='btmOpration'>
                    <div className='endTopic' onClick={endTopic}>
                        <AntdImage
                            src={newTopic}
                            preview={false}
                        />新建话题
                    </div>
                </div>


                {aIModalTips&&<div className='endTips' style={aIModalTips.position === 'top' ? {top:100, bottom: 'initial'}:{}}>
                    {
                        aIModalTips.status === "success" ? (
                            <CheckCircleOutlined />
                        ) : aIModalTips.status === "loading" ? (
                            <Spin size={"small"} style={{marginRight: 10,marginTop: '-2px'}}></Spin>
                        ):(
                            <CloseCircleOutlined />
                        )
                    }
                    {aIModalTips.msg}
                </div>}

                
                
                <div className={`inputQuestionBox ${isAnswering ? "answeringStatus" : ""}`}>
                    {/* 输入框 */}
                    <div className="inputBox">
                        <div
                            className='inputText'
                            placeholder={
                                (inputMessageLength > 0 || isAnswering) ? "" : 
                                !isAnswer ? '当前文档未解析完成':
                                "输入你的问题或需求(1000字以内)"}
                        >
                            {
                                isAnswering ? (<Spin tip={"答复中..."} size={"small"}></Spin>) : (
                                    <div
                                        id="inputContent"
                                        className="inputContent"
                                        // contentEditable={status != 0 ? false :true}
                                        onClick={(e) => {
                                            if (!isFocus) {
                                                moveEnd(e.target);
                                            }
                                        }}
                                        onBlur={(e) =>{
                                            setIsFocus(false)
                                        }}
                                        onInput={(val, e) => {
                                            inputSendText(val);
                                        }}
                                        dangerouslySetInnerHTML={{__html: inputText}}
                                        onKeyDown={(e) => {
                                            const {
                                                altKey, shiftKey, ctrlKey,
                                                key,
                                            } = e || {};

                                            if (key === "Enter" && !(altKey || shiftKey || ctrlKey)) {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                sendText();
                                            }
                                        }}
                                    ></div>
                                )
                            }
                        </div>
                        <div className="rightOpration">
                            <div className={`sendBtn ${((sendQuestionText || isAnswering) && isAnswer) ? 'active' : ''}`} onClick={() => {
                                if(!isAnswer){
                                    return false;
                                }
                                
                                if(isAnswering){
                                    stopAnswer()
                                }else if(!isAnswering && sendQuestionText){
                                    sendText()
                                }
                            }}>
                                {isAnswering ? <div className="stopIcon">■</div> : <ArrowUpOutlined />}
                            </div>
                        </div>
                    </div>
                </div>
            </div> ):null}
            
        </div>
    )
}

export default AIModalV7